module.exports = __webpack_public_path__ + "static/media/stork_dash.1d09565b.png";